import { MobilePreviewCourse, MobilePreviewImage } from './MobilePreview.type';

export class MobilePreviewMapper {
  
  // Mapeia dados do GraphQL Course para MobilePreviewCourse
  static fromGraphQLCourse(course: any): MobilePreviewCourse {
    return {
      id: course.id?.toString() || '',
      title: course.title || 'Sem título',
      description: course.description || course.resume || 'Sem descrição',
      cover: course.cover?.uri ? this.mapImage(course.cover) : undefined,
      poster: course.poster?.uri ? this.mapImage(course.poster) : undefined
    };
  }
  
  // Mapeia dados do Rails Course para MobilePreviewCourse
  static fromRailsCourse(course: any): MobilePreviewCourse {
    return {
      id: course.id?.toString() || '',
      title: course.title || 'Sem título',
      description: course.description || course.resume || 'Sem descrição',
      cover: course.cover?.uri ? this.mapImage(course.cover) : undefined,
      poster: course.poster?.uri ? this.mapImage(course.poster) : undefined
    };
  }
  
  // Mapeia arquivo de upload para MobilePreviewImage
  static fromUploadFile(file: any): MobilePreviewImage | null {
    if (!file) return null;
    
    const uri = file.preview || file.uri || file.url;
    if (!uri) return null;
    
    return {
      uri,
      uri_original: file.uri_original || uri
    };
  }
  
  // Helper para mapear imagem
  private static mapImage(image: any): MobilePreviewImage {
    return {
      uri: image.uri,
      uri_original: image.uri_original || image.uri
    };
  }
  
  // Mapeia array de cursos
  static fromCourseArray(courses: any[], type: 'graphql' | 'rails' = 'rails'): MobilePreviewCourse[] {
    if (!courses || !Array.isArray(courses)) return [];
    
    return courses.map(course => {
      return type === 'graphql' 
        ? this.fromGraphQLCourse(course)
        : this.fromRailsCourse(course);
    });
  }
}
